import GetInsightsPage from './Page';
export default GetInsightsPage;
